import { render } from "./TodaysCalls.vue?vue&type=template&id=e72b82d2"
import script from "./TodaysCalls.vue?vue&type=script&lang=js"
export * from "./TodaysCalls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__